// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2Jkkx","inner":"Footer_inner__3cjKT","nextIcon":"Footer_nextIcon__3Or5e","innerLeft":"Footer_innerLeft__d7ch5"};